import LegalLayout, { LegalSection } from "./LegalLayout";

export default function Privacy() {
  return (
    <LegalLayout label="PRIVACY POLICY" title="Privacy Policy" effective="December 2026">
      <p>
        Small Business Automator (&ldquo;SBA,&rdquo; &ldquo;we,&rdquo; &ldquo;us,&rdquo;
        or &ldquo;our&rdquo;) respects your privacy. This Privacy Policy explains
        what information we collect through smallbusinessautomator.com (the
        &ldquo;Site&rdquo;), how we use it, and the choices you have.
      </p>

      <LegalSection heading="1. Information We Collect">
        <p>We collect the following categories of information:</p>
        <ul className="list-disc pl-6 space-y-2">
          <li>
            <strong>Contact information</strong> you submit through our application form or
            calendar booking flow (first name, last name, email, phone number, state, monthly
            loan volume, and any additional information you share).
          </li>
          <li>
            <strong>Technical information</strong> automatically collected when you visit the
            Site — IP address, browser type, device, pages viewed, referring URL, and standard
            marketing attribution parameters (UTM values, fbclid, gclid).
          </li>
          <li>
            <strong>Marketing pixel data</strong> from the Meta Pixel and any comparable tools
            used to measure ad performance and page interactions.
          </li>
        </ul>
      </LegalSection>

      <LegalSection heading="2. How We Use Your Information">
        <p>We use the information we collect to:</p>
        <ul className="list-disc pl-6 space-y-2">
          <li>Respond to your inquiry, schedule and confirm your strategy call.</li>
          <li>Send appointment reminders, follow-ups, and information you specifically request.</li>
          <li>Improve our services, marketing, and Site performance.</li>
          <li>Comply with legal obligations.</li>
        </ul>
      </LegalSection>

      <LegalSection heading="3. SMS / Text Messaging (A2P 10DLC)">
        <p>
          When you submit your phone number and consent to receive text messages,
          you agree to receive SMS communications from Small Business Automator
          related to your inquiry, scheduled calls, follow-ups, and services you
          have requested. Message frequency varies. Message and data rates may
          apply. Reply <strong>HELP</strong> for help. Reply <strong>STOP</strong> at any time to opt out.
        </p>
        <p className="border-l-2 border-[#C9A84C]/60 pl-4 py-2 text-[#F0ECE4]">
          <strong>No sharing of mobile opt-in data.</strong> Mobile information and
          the consent you provide to receive text messages will not be shared
          with third parties or affiliates for marketing or promotional purposes.
          This exclusion applies to all sub-categories of information described
          in this Privacy Policy.
        </p>
      </LegalSection>

      <LegalSection heading="4. How We Share Information">
        <p>We share personal information only with:</p>
        <ul className="list-disc pl-6 space-y-2">
          <li>
            <strong>Service providers</strong> that help us operate the Site and deliver our
            services (for example, our CRM/scheduling platform, hosting, and email vendors),
            under contract and only for the purposes we specify.
          </li>
          <li>
            <strong>Legal authorities</strong> when required by law, subpoena, or to protect
            our rights and users.
          </li>
        </ul>
        <p>
          We do not sell your personal information. We do not share mobile opt-in
          data or SMS consent with third parties or affiliates for marketing or
          promotional purposes.
        </p>
      </LegalSection>

      <LegalSection heading="5. Cookies &amp; Tracking Technologies">
        <p>
          We use cookies, local/session storage, and marketing pixels (including the Meta Pixel)
          to remember attribution, measure ad performance, and improve the Site. You can control
          cookies through your browser settings. Disabling them may limit some Site functionality.
        </p>
      </LegalSection>

      <LegalSection heading="6. Data Retention">
        <p>
          We retain personal information for as long as necessary to fulfill the purposes
          described in this Policy, comply with legal obligations, and enforce our agreements.
        </p>
      </LegalSection>

      <LegalSection heading="7. Your Choices">
        <ul className="list-disc pl-6 space-y-2">
          <li>You may unsubscribe from marketing emails using the link in any message.</li>
          <li>You may opt out of SMS by replying STOP.</li>
          <li>
            You may request access, correction, or deletion of your personal information by
            emailing <a href="mailto:dallas@smallbusinessautomator.com" className="text-[#C9A84C] hover:underline">dallas@smallbusinessautomator.com</a>.
          </li>
        </ul>
      </LegalSection>

      <LegalSection heading="8. Children">
        <p>The Site is not directed to children under 16 and we do not knowingly collect their information.</p>
      </LegalSection>

      <LegalSection heading="9. Changes to This Policy">
        <p>We may update this Policy from time to time. The &ldquo;Last Updated&rdquo; date at the top reflects the most recent version.</p>
      </LegalSection>

      <LegalSection heading="10. Contact">
        <p>
          Questions? Email <a href="mailto:dallas@smallbusinessautomator.com" className="text-[#C9A84C] hover:underline">dallas@smallbusinessautomator.com</a>.
        </p>
      </LegalSection>
    </LegalLayout>
  );
}
